<template>
  <div id="booknew">
    <Navbar :booking="items" :setorders="orders" />
    <div class="space"></div>
    <b-container class="bv-example-row">
      <b-row>
        <b-col cols="4">
          <b-card class="avatar border-0 shadow">
            <b-card-body>
              <!-- <b-img src="../assets/icons/open-book.png" v-bind="mainProps" rounded="circle" alt="Circle image"></b-img> -->
              <img
                src="../assets/icons/studio_.png"
                alt=""
                width=""
                height=""
                class="avatar-img rounded-circle circle-image"
              />
            </b-card-body>
          </b-card>
        </b-col>

        <b-col cols="8">
          <b-row> </b-row>
          <b-card-group deck class="mb-12">
            <b-card class="avatar border-0 shadow">
              <b-card-body> </b-card-body>
            </b-card>
            <!-- body -->
            <b-card class="avatar border-0 shadow">
              <b-card-body> </b-card-body>
            </b-card>
          </b-card-group>
        </b-col>
      </b-row>
    </b-container>
    <div class="space"></div>
    <Footer />
  </div>
</template>

<script>
import axios from "axios";
import Footer from "./layouts/footer.vue";
import $ from "jquery";
import Navbar from "./layouts/navbar.vue";
// import VueHorizontalCalendar from "vue-horizontal-calendar";
import moment from "moment";
export default {
  components: { Footer, Navbar },
  name: "Booknew",
  data() {
    return {
      token: "dQpojB8WkH7HAZdh223jaqFSB1x5RYoKBjU0BAaVZt8DTVaxO5Sx5DlsErA2Zsu",
      tokenjong: "NDMyMTNDNUYtRkZFNy00NjI1LUIwNTQtMkQ0QTkzOTIyQTM3",
      checked: true,
      auth: [],
      items: [],
      orders: [],
      value: "",
      hideRoom: false,
      slide: 0,
      sliding: null,
      dateTime: new Date(),
      choosedDay2: {
        dateFormat: "",
        year: "",
        month: "",
        date: "",
        day: "",
        timestamp: "",
      },
      showModal: false,
      status_room: [],
      input_stdcode: [{}],
      code: "",
      date: "",
      selected: null,
      selected2: null,
      selected3: null,
      options: [],
      dbroom: [],
      dbroomMax: "",
      dbroomMin: "",
      stdr: [],
      values: {},
      res: [],
      error: "",
      status_show: false,
      input_another: "",
      isShowstaff: false,
      input_room_Teacher: {
        phone: "",
        name: "",
        fac: null,
        branch: null,
        email: "",
      },
      user: false,
      history: [],
      mainProps: {
        blank: true,
        blankColor: "#777",
        width: 75,
        height: 75,
        class: "m1",
      },
    };
  },
  computed: {},
  filters: {
    moment: function (date) {
      moment.locale("th");
      return moment(date).add(543, "year").format("LL");
    },
  },
  mounted() {
    if (localStorage.getItem("auth") != null) {
      this.user = false;
      this.auth = JSON.parse(localStorage.getItem("auth"));
      this.code = this.auth.std_code;
      // console.log(this.auth);
      if (this.auth.user_type === "Teacher" || this.auth.isLibraryStaff === 0) {
        this.isShowstaff;
      } else if (this.auth.user_type === "Student") {
        this.isShowstaff = true;
      }
      this.getbook();
      if (this.auth.isLibraryStaff === 1) {
        this.staff = true;
      } else {
        this.staff = false;
      }

      if (localStorage.getItem("orders") != null) {
        this.loadOrder();
      }
    } else {
      this.user = true;
      this.isShowstaff = true;
    }
    this.getorders();
    if (localStorage.getItem("booking") != null) {
      this.loadBooking();
    }
    this.getHistory();
    //
    window.setTimeout(function () {
      $(".alert")
        .fadeTo(500, 0)
        .slideUp(500, function () {
          $(this).remove();
        });
    }, 4000);
    //
    /*! Main */
    (function ($) {
      "use strict";

      var $navbar = $("#nav"),
        y_pos = $navbar.offset().top,
        height = $navbar.height();

      $(document).scroll(function () {
        var scrollTop = $(this).scrollTop();

        if (scrollTop > y_pos + height) {
          $navbar.addClass("fixed-top").animate({
            top: 0,
          });
          $navbar.addClass("shadow mb-5 bg-white rounded");
        } else if (scrollTop <= y_pos) {
          $navbar.removeClass("fixed-top").clearQueue().animate(
            {
              top: "-48px",
            },
            0
          );
          $navbar
            .removeClass("shadow p-3 mb-5 bg-white rounded")
            .clearQueue()
            .animate(
              {
                top: "-48px",
              },
              0
            );
        }
      });
    })($, undefined);
  },

  methods: {
    // getbook: function() {
    //   axios
    //     .post("https://smartlibrary.ubru.ac.th/api/get_newbook", this.token)
    //     .then((res) => {
    //       this.databook = res.data.books;
    //     })
    //     .catch((e) => {
    //       this.error.push(e);
    //     });
    // },
    close(id) {
      // console.log("close ");
      this.$bvModal.hide(id);
    },
    addFind() {
      this.stdr.push({ value: "" });
      // console.log("v modal ==", this.stdr);
    },
    ctrlShiftkey(e, keyCode) {
      return e.ctrlKey && e.shiftKey && e.keyCode == keyCode.charCodeAt(0);
    },
    dateClass(ymd, date) {
      const day = date.getDate();

      // Return `true` if the date should be disabled

      return day >= 10 && day <= 20 ? "table-info" : "";
    },
    dateDisabled(ymd, date) {
      // Disable weekends (Sunday = `0`, Saturday = `6`) and
      // disable days that fall on the 13th of the month
      const weekday = date.getDay();
      const day = date.getDate();
      // Return `true` if the date should be disabled
      return weekday === 0 || weekday === 6 || day === 13;
    },
    getorders() {
      let data = {
        token: this.token,
        std_code: this.code,
      };
      const headers = {
        "content-type": "application/json",
      };

      axios
        .post("https://smartlibrary.ubru.ac.th/api/booking/getorder", data, {
          headers,
        })
        .then((res) => {
          // console.log(res);
          if (res.data.msg.status != 200) {
            alert(res.data.msg.message);
          } else {
            if (res.data.Orders !== null) {
              this.orders = res.data.Orders;
              for (var i in this.orders) {
                if (this.orders[i].order_status === 5) {
                  this.orders.splice(this.orders.indexOf(this.orders[i]), 1);
                }
              }

              localStorage.setItem("orders", JSON.stringify(this.orders));
              this.show = true;
            }
          }
        });
    },

    getHistory() {
      let data = {
        select_date: this.choosedDay2.dateFormat,
        std_code: this.code,
      };
      // console.log("get story data ==", data);
      const token = this.tokenjong;
      const headers = {
        Authorization: `Bearer ${token}`,
      };
      axios
        .post("https://smartlibrary.ubru.ac.th/api/get_history_per_std", data, {
          headers,
        })
        .then((res) => {
          // console.log("res history==", res);
          this.history = res.data.histories;
          // console.log("History", this.history);
          if (this.history.length === 0) {
            this.status_show = false;
          } else {
            // console.log("true");
            this.status_show = true;
          }
        });
    },
    loadOrder() {
      this.orders = JSON.parse(localStorage.getItem("orders"));
    },
    loadBooking() {
      this.items = JSON.parse(localStorage.getItem("booking"));
    },
    getbook() {
      let ip = localStorage.getItem("IP");

      let data = {
        token: this.token,
        std_code: this.code,
        public_ip: ip,
      };
      const headers = {
        "content-type": "application/json",
      };
      this.$isLoading(true);
      axios
        .post(
          "https://smartlibrary.ubru.ac.th/api/booking/get_loan_all",
          data,
          { headers }
        )
        .then((res) => {
          if (res.data[0].msg.status != 200) {
            this.$isLoading(false);
            alert(res.data.msg.message);
          } else {
            this.$isLoading(false);

            this.books = res.data[0].loan_current;
            // console.log(this.books);
            this.maxRenew = res.data[0].loan_summary[0].max_renew;
          }
        });
    },
    renew() {
      let ip = localStorage.getItem("IP");

      let data = {
        token: this.token,
        std_code: this.code,
        public_ip: ip,
      };
      const headers = {
        "content-type": "application/json",
      };
      this.$isLoading(true);
      axios
        .post("https://smartlibrary.ubru.ac.th/api/booking/renew", data, {
          headers,
        })
        .then((res) => {
          if (res.data[0].msg.status != 200) {
            this.$isLoading(false);
            alert(res.data.msg.message);
          } else {
            this.$isLoading(false);
            this.books = res.data[0].loan_current;
            this.maxRenew = res.data[0].loan_summary[0].max_renew;
          }
        });
    },
    onContext(ctx) {
      this.context = ctx;
    },
    onSlideStart() {
      this.sliding = true;
    },
    onSlideEnd() {
      this.sliding = false;
    },

    doSomething() {
      // console.log("selectDate=", e);
    },
    booking(room_id, time_begin, time_end, time_id, id) {
      // console.log(" another ==", this.input_another);
      // var arr = [];
      let ip = localStorage.getItem("IP");

      for (var key of Object.keys(this.values)) {
        this.res.push(this.values[key]);
      }

      let data = {
        select_date: this.choosedDay2.dateFormat,
        room_id: room_id,
        time_id: time_id,
        time_begin: time_begin,
        time_end: time_end,
        usefor_id: this.selected,
        std_code: this.res,
        public_ip: ip,
        whois_std_code: this.code,
      };
      // console.log("Booking ===", data);
      const token = this.tokenjong;
      const headers = {
        Authorization: `Bearer ${token}`,
      };
      axios
        .post("https://smartlibrary.ubru.ac.th/api/step3_confirm", data, {
          headers,
        })
        .then((res) => {
          // console.log("chk ststus booking ==", res.data.msg.status);
          if (res.data.msg.status == 200) {
            // this.status_show = true;
            this.$bvModal.hide(id);
            //  router.push('/meetingRoom');
            // console.log("true Booking ");
          } else {
            this.error = res.data.msg.message;
            this.res = [];
          }

          // console.log(res.data);
        });
    },
    bookingAnother(room_id, time_begin, time_end, time_id, id) {
      // console.log(
      //   "booking  Another",
      //   room_id,
      //   time_begin,
      //   time_end,
      //   time_id,
      //   id
      // );
      // console.log(this.input_room_Teacher);
      this.$bvModal.hide(id);
    },
  },
};
</script>

<style scoped>
/* ======== */
.space {
  height: 60px;
}
.avatar {
  border-radius: 20px;
}
.avatar-img {
  /* border-radius: 50%; */
  width: 100%;
  height: auto;
}
</style>
